import React from "react";

import type { PlayerTickState } from "../shared";

export function Hud({ player }: { player: PlayerTickState | undefined }) {
	if (!player) return null;
	return (
		<div className="hud">
			<span className="hud-stat hud-stat--lives">
				{"♥".repeat(Math.max(0, player.lives)) || "—"}
			</span>
			<span className="hud-stat hud-stat--score">
				<span className="hud-stat-label">Score</span>
				{player.score}
			</span>
			{player.finished && <span className="hud-banner">Finished! Final score: {player.score}</span>}
			{player.gameOver && <span className="hud-banner hud-banner--danger">Game Over</span>}
		</div>
	);
}
